import { Injectable } from '@angular/core';

interface Params {
    [key: string]: any;
}

@Injectable()
export class SelectService {

    constructor() {
        //
    }

    public search(query: string, columns: Array<string>, defaults: Params = null): string {
        let search = {};

        if (defaults) {
            // Set the default search entries.
            for (const property in defaults) {
                if (defaults.hasOwnProperty(property)) {
                    search[property] = defaults[property];
                }
            }
        }

        if (query) {
            // Set the search entries.
            search = columns.reduce((previous: { [key: string]: any }, column: string) => {
                previous[column] = query;
                return previous;
            }, search);
        }

        return this.parse(search);
    }

    protected parse(data: { [key: string]: any }): string {
        return Object
            .keys(data)
            .map((key) => {
                const value = data[key];
                return key + ':' + value;
            })
            .join(';')
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/forms/form/services/select.service.ts